<template>
    <b-row class="text-justify mb-3">
        <b-table :fields="fields" :items="items" :busy="tableBusy" :current-page="currentPage" hover no-border-collapse
            sort-by="" :sort-desc="true" striped stacked="lg" show-empty>
            <template #empty>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #table-busy>
                <div class="text-center text-dark">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="loading-text">Carregando...</strong>
                </div>
            </template>
        </b-table>
        <table-pagination v-if="totalRows > 10" :total-rows="totalRows" :per-page="10" @pageChange="pageChange" />
    </b-row>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'

import ldiService from '@/services/licitacoes/ldiService'
import { TableField } from '@/types/table-field'

import TablePagination from '@/components/atos-pessoal/TablePagination.vue'
import { fieldsFracassados } from '@/types/licitacoes/ldi/fields-fracassados'
import { LicitacaoFracassado } from '@/types/licitacoes/ldi/licitacao-fracassado'

const CompProps = Vue.extend({
    name: 'DetalhesFracassados',
    components: { TablePagination },
    props: {
        idLicitacao: {
            type: Number,
            required: true
        },
    }
})

@Component
export default class DetalhesFracassados extends mixins(UtilsTS, CompProps) {
    fields: TableField[] = fieldsFracassados
    items: LicitacaoFracassado[] = []

    //table-related
    currentPage = 1
    pageSize = 10
    totalRows = 0
    tableBusy = false

    async mounted() {
        await this.loadData()
    }
    async pageChange(value) {
        this.currentPage = value;
        await this.loadData();
    }
    async loadData(): Promise<void> {
        try {
            this.tableBusy = true
            const response = await ldiService.buscarFracassados(this.idLicitacao, this.currentPage, this.pageSize)
            console.log(response)
            if (response) {
                this.items = response.itens.map(l => {
                    const item = Object.assign(new LicitacaoFracassado(), l)
                    item.tratarDadosDaAPI()
                    return item
                })
                this.totalRows = response.totalRows
            } else {
                this.$toast.error('Erro ao consultar os fracassados da licitação.');
            }
        } catch (e) {
            console.error(e)
            this.$toast.error('Falha ao buscar fracassados. ' + e)
        } finally {
            this.tableBusy = false
        }
    }
}
</script>

<style scoped></style>